<template>
  <bb-banner
    type="warning"
    class="f-color-gray"
    visible
    permanent
    :title="translations.availableBalanceWarning.title"
    data-testid="available-balance-warning"
  >
    <div v-sanitize.basic="translations.availableBalanceWarning.description"></div>
    <div v-sanitize.basic="translations.availableBalanceWarning.action"></div>
    <div class="m-t-5 d-flex align-items-center gap-5">
      <strong class="uppercase">{{ translations.availableBalanceWarning.iban }}:</strong>
      {{ selectedIban }}
      <info-box-copy-button :item="selectedIban" size="sm"/>
    </div>
  </bb-banner>
</template>

<script>
import InfoBoxCopyButton from '@deposits/components/InfoBoxCopyButton.vue'

export default {
  name: 'available-balance-warning-banner',
  components: { InfoBoxCopyButton },
  props: {
    availableBalance: {
      type: String,
      required: true
    },
    selectedIban: {
      type: String,
      required: true
    }
  },
  computed: {
    translations () {
      return {
        availableBalanceWarning: {
          title: this.$pgettext('pending_payment_table', 'You reached your available balance'),
          description: this.$gettextInterpolate(this.$pgettext('pending_payment_table',
            'The sum of selected payments exceeds the available balance of <strong>%{amount}</strong> '), {
            amount: this.availableBalance
          }),
          action: this.$pgettext('pending_payment_table', '<strong>Actions:</strong> Edit your payment amount or add funds to your account'),
          iban: this.$gettext('IBAN')
        }
      }
    }
  }
}
</script>
